import { Component, OnInit, Input } from "@angular/core";
import { Store } from "@ngrx/store/src/store";
import { AppState } from "@store/app-state";
import { Timeslot } from "@models/timeslot";
import { TwoWeekBlock } from "@models/two-week-block";
import { TutorTimeslots } from "@models/tutor-timeslots";
import { Booking } from "@models/booking";
import { BookingFormComponent } from "./booking-form";
import { BookingRemovalFormComponent } from "./booking-removal-form";
import { ModalService, ModalConfig } from "@services/modal";
import * as moment from "moment";
import { Contact } from "@models/contact";
import { POPULATE_EDITABLE_BOOKING } from "@reducers/bookings";

@Component({
  selector: 'timeslots-table',
  templateUrl: './timeslots-table.pug',
})
export class TimeslotsTableComponent implements OnInit {

  public readonly S_AVAILABLE                     = "S_AVAILABLE"
  public readonly S_AVAILABLE_WITH_REPLACEMENT    = "S_AVAILABLE_WITH_REPLACEMENT"
  public readonly S_BOOKED                        = "S_BOOKED"
  public readonly S_BOOKED_BUT_CANCELLED_SAME_DAY = "S_BOOKED_BUT_CANCELLED_SAME_DAY"
  public readonly S_TUTOR_ABSENT                  = "S_TUTOR_ABSENT"
  public readonly S_TUTOR_ABSENT_W_BOOKING_NO_REPLACEMENT =
    "S_TUTOR_ABSENT_W_BOOKING_NO_REPLACEMENT"
  public readonly S_TUTOR_ABSENT_W_BOOKING_HAS_REPLACEMENT =
    "S_TUTOR_ABSENT_W_BOOKING_HAS_REPLACEMENT"

  @Input() public tutorTimeslots: TutorTimeslots[]
  @Input() public twoWeekBlock: TwoWeekBlock
  @Input() public window: Window

  constructor(
    public store: Store<AppState>,
    public modalService: ModalService,
  ) {}

  gTutorCount(): number {
    let result = 0
    if (this.tutorTimeslots.length > 0) {
      result = this.tutorTimeslots[0].byTutor.length
    }
    return result
  }

  gTsHeaders(): string[] {
    if (!this.tutorTimeslots[0].byTutor) { return [] }

    return this.tutorTimeslots[0].byTutor[0].timeslots.map((t: Timeslot) => {
      return `
      ${moment(t.startTime).format("HH:mma")} 
      - 
      ${moment(t.endTime).format("HH:mma")}
    `
    })
  }

  getTwoWeekBlockTitleHtml(i: number): string {
    const date = i == 0 ?
      this.twoWeekBlock.startDate : this.twoWeekBlock.secondWeekStart

    return `
      <label>Week ${this.twoWeekBlock.index + 2 + i}</label>
      Starts: ${moment(date).format("ddd Do MMM")}
      <span>${moment(date).format("(D/M/YY)")}</span>`
  }

  getStatusClass(unformattedStatus: string): string {
    return unformattedStatus
      .replace(/S_/, "")
      .replace(/_/g, "-")
      .toLowerCase()
  }

  getTimeslotColumnWidth() {
    return { 'width': `${Math.floor(100 / this.gTutorCount())}%` }
  }

  clickedBookTimeslot(timeslot: Timeslot, tutor: Contact, period: number) {
    const booking               = new Booking()
    booking.period              = period
    booking.date                = timeslot.date
    booking.windowId            = timeslot.windowId

    if (timeslot.replacementTutorAllocation) {
      booking.previousTutorAllocationId = tutor.tutorAllocationId
      booking.tutorAllocationId         = timeslot.replacementTutorAllocation.id
    }
    else {
      booking.tutorAllocationId         = timeslot.tutorAllocation.id
    }

    this.store.dispatch({ type: POPULATE_EDITABLE_BOOKING, payload: booking })
    this.modalService.showModal(
      new ModalConfig(
        BookingFormComponent,
        { timeslot, tutor, period, mode: "new" }))
  }

  clickedEditTimeslot(timeslot: Timeslot, tutor: Contact, period: number) {
    this.store.dispatch({ type: POPULATE_EDITABLE_BOOKING, payload: timeslot.booking })
    this.modalService.showModal(
      new ModalConfig(
        BookingFormComponent,
        { timeslot, tutor, period, mode: "edit" }))
  }

  clickedClearTimeslot(timeslot: Timeslot, tutor: Contact, period: number) {
    this.store.dispatch({ type: POPULATE_EDITABLE_BOOKING, payload: timeslot.booking })
    this.modalService.showModal(new ModalConfig(BookingRemovalFormComponent))
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/timeslots-table.ts